import React, { useEffect } from "react";

const Pagination = ({ Data, page, setPage, getMethod, entries }) => {
  const prevHandler = () => {
    if (page > 1) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  const nextHandler = () => {
    if (Data?.length == entries) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getMethod();
    };

    fetchData();
  }, [page]);

  return (
    <div className="flex border rounded  text-sm">
      {/* previous */}
      <button
        type="button"
        onClick={prevHandler}
        className={`border border-[#F4881F] px-5 py-2 text-white
          ${
            page > 1
              ? "border-[#F4881F] bg-[#F4881F]"
              : "border-gray-300 bg-gray-300"
          }
         rounded-s`}
      >
        Prev
      </button>

      {/*Page Count  */}
      <div className="border px-5 py-2 border-[#F4881F] ">{page}</div>

      {/* Next Button */}
      <button
        type="button"
        onClick={nextHandler}
        className={`border border-[#F4881F] px-5 py-2 text-white ${
          Data?.length == entries
            ? "border-[#F4881F] bg-[#F4881F]"
            : "border-gray-300 bg-gray-300"
        } rounded-e`}
        disabled={!Data?.length}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
